import React from 'react';
import { Route } from 'react-router-dom';
import loadableModule from 'spark-views/main/loadableModule';
import Permission from 'spark-util/Permission';
import { paths } from './auditReportRoutes';

const AuditReport = loadableModule(() => import('./index.js'));

/* Loading the path/component for Audit Reports - SAF-13055*/

const AuditReportsRoute = () => (
	<Permission requires="sm.auditReports">
		<Route path={paths.root} component={AuditReport} />
	</Permission>
);

export default AuditReportsRoute;
